
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.4.0
 * Query Engine version: f352a33b70356f46311da8b00d83386dd9f145d6
 */
Prisma.prismaVersion = {
  client: "4.4.0",
  engine: "f352a33b70356f46311da8b00d83386dd9f145d6"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AndTargetScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  complexTargetId: 'complexTargetId'
});

exports.Prisma.BlockCategoryScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  name: 'name',
  siteID: 'siteID'
});

exports.Prisma.BoxBackgroundScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  boxSettingsId: 'boxSettingsId',
  positionX: 'positionX',
  positionY: 'positionY',
  width: 'width',
  height: 'height',
  imageId: 'imageId',
  colorId: 'colorId',
  verticalPosition: 'verticalPosition'
});

exports.Prisma.BoxBlockScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  boxId: 'boxId'
});

exports.Prisma.BoxBorderScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
  colorId: 'colorId',
  boxSettingsId: 'boxSettingsId',
  siteId: 'siteId'
});

exports.Prisma.BoxScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  parentBoxId: 'parentBoxId',
  widthType: 'widthType',
  widthTypeMobileResponsiveMode: 'widthTypeMobileResponsiveMode',
  widthTypeTabletResponsiveMode: 'widthTypeTabletResponsiveMode',
  widthTypeDesktopResponsiveMode: 'widthTypeDesktopResponsiveMode',
  heightType: 'heightType',
  heightTypeMobileResponsiveMode: 'heightTypeMobileResponsiveMode',
  heightTypeTabletResponsiveMode: 'heightTypeTabletResponsiveMode',
  heightTypeDesktopResponsiveMode: 'heightTypeDesktopResponsiveMode',
  positionTypeMobileResponsiveMode: 'positionTypeMobileResponsiveMode',
  positionTypeTabletResponsiveMode: 'positionTypeTabletResponsiveMode',
  positionTypeDesktopResponsiveMode: 'positionTypeDesktopResponsiveMode',
  hiddenMobileResponsiveMode: 'hiddenMobileResponsiveMode',
  hiddenTabletResponsiveMode: 'hiddenTabletResponsiveMode',
  hiddenDesktopResponsiveMode: 'hiddenDesktopResponsiveMode',
  overflowHiddenMobileResponsiveMode: 'overflowHiddenMobileResponsiveMode',
  overflowHiddenTabletResponsiveMode: 'overflowHiddenTabletResponsiveMode',
  overflowHiddenDesktopResponsiveMode: 'overflowHiddenDesktopResponsiveMode',
  gapMobileResponsiveMode: 'gapMobileResponsiveMode',
  gapTabletResponsiveMode: 'gapTabletResponsiveMode',
  gapDesktopResponsiveMode: 'gapDesktopResponsiveMode',
  widthMobileResponsiveMode: 'widthMobileResponsiveMode',
  widthTabletResponsiveMode: 'widthTabletResponsiveMode',
  widthDesktopResponsiveMode: 'widthDesktopResponsiveMode',
  heightMobileResponsiveMode: 'heightMobileResponsiveMode',
  heightTabletResponsiveMode: 'heightTabletResponsiveMode',
  heightDesktopResponsiveMode: 'heightDesktopResponsiveMode',
  marginMobileResponsiveMode: 'marginMobileResponsiveMode',
  marginTabletResponsiveMode: 'marginTabletResponsiveMode',
  marginDesktopResponsiveMode: 'marginDesktopResponsiveMode',
  paddingMobileResponsiveMode: 'paddingMobileResponsiveMode',
  paddingTabletResponsiveMode: 'paddingTabletResponsiveMode',
  paddingDesktopResponsiveMode: 'paddingDesktopResponsiveMode',
  positionMobileResponsiveMode: 'positionMobileResponsiveMode',
  positionTabletResponsiveMode: 'positionTabletResponsiveMode',
  positionDesktopResponsiveMode: 'positionDesktopResponsiveMode',
  backgroundMobileResponsiveMode: 'backgroundMobileResponsiveMode',
  backgroundTabletResponsiveMode: 'backgroundTabletResponsiveMode',
  backgroundDesktopResponsiveMode: 'backgroundDesktopResponsiveMode',
  borderRadiusMobileResponsiveMode: 'borderRadiusMobileResponsiveMode',
  borderRadiusTabletResponsiveMode: 'borderRadiusTabletResponsiveMode',
  borderRadiusDesktopResponsiveMode: 'borderRadiusDesktopResponsiveMode',
  borderMobileResponsiveMode: 'borderMobileResponsiveMode',
  borderTabletResponsiveMode: 'borderTabletResponsiveMode',
  borderDesktopResponsiveMode: 'borderDesktopResponsiveMode',
  shadowMobileResponsiveMode: 'shadowMobileResponsiveMode',
  shadowTabletResponsiveMode: 'shadowTabletResponsiveMode',
  shadowDesktopResponsiveMode: 'shadowDesktopResponsiveMode',
  responsiveBoxSettingsId: 'responsiveBoxSettingsId',
  text: 'text',
  isSliderShell: 'isSliderShell',
  isSlider: 'isSlider',
  isSliderArrowNext: 'isSliderArrowNext',
  isSliderArrowPrev: 'isSliderArrowPrev',
  isClosePopup: 'isClosePopup',
  isInput: 'isInput',
  tableColumnDataOutputID: 'tableColumnDataOutputID',
  pinTableID: 'pinTableID',
  tableImageIsCover: 'tableImageIsCover'
});

exports.Prisma.BoxSettingsScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  widthType: 'widthType',
  heightType: 'heightType',
  positionType: 'positionType',
  positionX: 'positionX',
  positionY: 'positionY',
  marginTop: 'marginTop',
  marginLeft: 'marginLeft',
  marginBottom: 'marginBottom',
  marginRight: 'marginRight',
  paddingTop: 'paddingTop',
  paddingLeft: 'paddingLeft',
  paddingBottom: 'paddingBottom',
  paddingRight: 'paddingRight',
  borderRadiusLeftTop: 'borderRadiusLeftTop',
  borderRadiusLeftBottom: 'borderRadiusLeftBottom',
  borderRadiusRightTop: 'borderRadiusRightTop',
  borderRadiusRightBottom: 'borderRadiusRightBottom',
  width: 'width',
  height: 'height',
  hidden: 'hidden',
  isOverflowHidden: 'isOverflowHidden',
  vector: 'vector',
  horizontalPosition: 'horizontalPosition',
  verticalPosition: 'verticalPosition',
  gap: 'gap',
  shadowId: 'shadowId',
  order: 'order'
});

exports.Prisma.BoxShadowScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  originalID: 'originalID',
  viewName: 'viewName',
  xShift: 'xShift',
  yShift: 'yShift',
  blur: 'blur',
  spread: 'spread',
  colorId: 'colorId',
  siteId: 'siteId'
});

exports.Prisma.BySecondsLaunchEventScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteV1Id: 'siteV1Id',
  seconds: 'seconds'
});

exports.Prisma.CodeComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  code: 'code'
});

exports.Prisma.ColorScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  siteV1Id: 'siteV1Id',
  name: 'name',
  viewName: 'viewName',
  value: 'value',
  originalID: 'originalID'
});

exports.Prisma.CompanyAddressScalarFieldEnum = makeEnum({
  id: 'id',
  siteV1Id: 'siteV1Id',
  address: 'address',
  addressLng: 'addressLng',
  addressLat: 'addressLat'
});

exports.Prisma.CompanyMailScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteV1Id: 'siteV1Id',
  mail: 'mail',
  text: 'text'
});

exports.Prisma.CompanyPhoneScalarFieldEnum = makeEnum({
  id: 'id',
  siteV1Id: 'siteV1Id',
  phone: 'phone',
  text: 'text'
});

exports.Prisma.ComplexTargetScalarFieldEnum = makeEnum({
  id: 'id',
  siteV1Id: 'siteV1Id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  yandexMetrikaTargetId: 'yandexMetrikaTargetId'
});

exports.Prisma.CountVisitScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  monthYear: 'monthYear',
  count: 'count',
  siteID: 'siteID'
});

exports.Prisma.DomainV1ScalarFieldEnum = makeEnum({
  id: 'id',
  domain: 'domain',
  lastCertificateReleaseDate: 'lastCertificateReleaseDate',
  userId: 'userId'
});

exports.Prisma.ExtraInputV1ScalarFieldEnum = makeEnum({
  id: 'id',
  formV1Id: 'formV1Id',
  order: 'order',
  placeholder: 'placeholder',
  bitrixFieldName: 'bitrixFieldName',
  type: 'type',
  isRequired: 'isRequired'
});

exports.Prisma.FaqComponentItemScalarFieldEnum = makeEnum({
  id: 'id',
  faqComponentId: 'faqComponentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  order: 'order',
  question: 'question',
  answer: 'answer'
});

exports.Prisma.FaqComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId'
});

exports.Prisma.FontWeightScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteID: 'siteID',
  previewName: 'previewName',
  name: 'name',
  folder: 'folder',
  size: 'size',
  groupFontID: 'groupFontID'
});

exports.Prisma.FormComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  formId: 'formId'
});

exports.Prisma.FormSendedEventScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteV1Id: 'siteV1Id',
  formSendedId: 'formSendedId'
});

exports.Prisma.FormV1ScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteId: 'siteId',
  title: 'title',
  description: 'description',
  formButtonText: 'formButtonText',
  name: 'name',
  targetID: 'targetID',
  linkID: 'linkID'
});

exports.Prisma.GenerateGPTOutcomeBalanceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  dayMonthYear: 'dayMonthYear',
  amount: 'amount'
});

exports.Prisma.GroupFontScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  siteID: 'siteID'
});

exports.Prisma.ImageComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  imageId: 'imageId',
  width: 'width',
  height: 'height',
  positionX: 'positionX',
  positionY: 'positionY',
  shellWidth: 'shellWidth',
  shellHeight: 'shellHeight',
  isCover: 'isCover'
});

exports.Prisma.ImageV1ScalarFieldEnum = makeEnum({
  type: 'type',
  id: 'id',
  name: 'name',
  folder: 'folder',
  size: 'size',
  createdAt: 'createdAt',
  width: 'width',
  height: 'height',
  originalID: 'originalID',
  isS3: 'isS3',
  siteId: 'siteId'
});

exports.Prisma.IncomeBalanceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  amount: 'amount'
});

exports.Prisma.LeadV1ScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  type: 'type',
  id: 'id',
  information: 'information',
  siteV1Id: 'siteV1Id',
  AmazonEmailMessageId: 'AmazonEmailMessageId'
});

exports.Prisma.LinkV1ScalarFieldEnum = makeEnum({
  type: 'type',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  textLink: 'textLink',
  boxId: 'boxId',
  pageId: 'pageId',
  sectionCollectionId: 'sectionCollectionId',
  sectionId: 'sectionId',
  popupId: 'popupId',
  popupData: 'popupData',
  url: 'url'
});

exports.Prisma.MapComponentPointScalarFieldEnum = makeEnum({
  id: 'id',
  mapComponentId: 'mapComponentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lat: 'lat',
  lng: 'lng',
  linkID: 'linkID',
  text: 'text'
});

exports.Prisma.MapComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  zoom: 'zoom',
  zoomFloat: 'zoomFloat',
  centerLat: 'centerLat',
  centerLng: 'centerLng'
});

exports.Prisma.OrTargetScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  complexTargetId: 'complexTargetId'
});

exports.Prisma.OutcomeBalanceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  amount: 'amount'
});

exports.Prisma.PageOpenedEventScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteV1Id: 'siteV1Id',
  pageId: 'pageId'
});

exports.Prisma.PageV1ScalarFieldEnum = makeEnum({
  id: 'id',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pathname: 'pathname',
  hidden: 'hidden',
  title: 'title',
  description: 'description',
  siteV1Id: 'siteV1Id',
  showFooterSections: 'showFooterSections',
  showHeaderSections: 'showHeaderSections',
  pinTableID: 'pinTableID'
});

exports.Prisma.PaidPlaceOutcomeBalanceScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  amount: 'amount',
  paidPlaceId: 'paidPlaceId',
  start: 'start',
  end: 'end'
});

exports.Prisma.PaidPlaceScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  name: 'name',
  userId: 'userId',
  isArchive: 'isArchive',
  isFree: 'isFree',
  paidUntil: 'paidUntil',
  notifiedAboutPaymentBeforeThreeDays: 'notifiedAboutPaymentBeforeThreeDays',
  notifiedAboutPaymentBeforeTwoDays: 'notifiedAboutPaymentBeforeTwoDays',
  notifiedAboutPaymentBeforeOneDays: 'notifiedAboutPaymentBeforeOneDays',
  notifiedAboutPaymentBeforeZeroDays: 'notifiedAboutPaymentBeforeZeroDays'
});

exports.Prisma.PartnerIncomeScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  paidPlaceOutcomeBalanceID: 'paidPlaceOutcomeBalanceID',
  partnerID: 'partnerID'
});

exports.Prisma.PartnerOutcomeScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  partnerID: 'partnerID'
});

exports.Prisma.PartnerScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  monthPayment: 'monthPayment',
  yearPayment: 'yearPayment',
  monthPercent: 'monthPercent',
  yearPercent: 'yearPercent',
  balance: 'balance',
  code: 'code',
  partnerUserOwnerID: 'partnerUserOwnerID'
});

exports.Prisma.PopupOpenedEventScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteV1Id: 'siteV1Id',
  popupOpenedId: 'popupOpenedId'
});

exports.Prisma.PopupV1ScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  siteV1Id: 'siteV1Id',
  formId: 'formId',
  quizV1Id: 'quizV1Id',
  verticalPosition: 'verticalPosition',
  horizontalPosition: 'horizontalPosition',
  boxId: 'boxId',
  boxBlockId: 'boxBlockId'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.QuizComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  quizId: 'quizId'
});

exports.Prisma.QuizV1CheckboxItemV1ScalarFieldEnum = makeEnum({
  type: 'type',
  order: 'order',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  checkboxStepV1Id: 'checkboxStepV1Id',
  targetID: 'targetID',
  imageID: 'imageID'
});

exports.Prisma.QuizV1CheckboxStepV1ScalarFieldEnum = makeEnum({
  type: 'type',
  order: 'order',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  quizStepV1Id: 'quizStepV1Id'
});

exports.Prisma.QuizV1FieldInputStepV1ScalarFieldEnum = makeEnum({
  type: 'type',
  order: 'order',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  placeholder: 'placeholder',
  quizStepV1Id: 'quizStepV1Id'
});

exports.Prisma.QuizV1RadioItemV1ScalarFieldEnum = makeEnum({
  type: 'type',
  order: 'order',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  radioStepV1Id: 'radioStepV1Id',
  targetID: 'targetID',
  imageID: 'imageID'
});

exports.Prisma.QuizV1RadioStepV1ScalarFieldEnum = makeEnum({
  type: 'type',
  id: 'id',
  order: 'order',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  quizStepV1Id: 'quizStepV1Id'
});

exports.Prisma.QuizV1ScalarFieldEnum = makeEnum({
  id: 'id',
  siteId: 'siteId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  title: 'title',
  description: 'description',
  formId: 'formId',
  mainColorID: 'mainColorID',
  textColorID: 'textColorID',
  buttonTextColorID: 'buttonTextColorID'
});

exports.Prisma.QuizV1StepV1ScalarFieldEnum = makeEnum({
  id: 'id',
  order: 'order',
  quizV1Id: 'quizV1Id',
  isItemWithImage: 'isItemWithImage'
});

exports.Prisma.ResponsiveBoxSettingsScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  desktopBoxSettingsId: 'desktopBoxSettingsId',
  tabletBoxSettingsId: 'tabletBoxSettingsId',
  mobileBoxSettingsId: 'mobileBoxSettingsId'
});

exports.Prisma.RobokassaPaymentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  InvId: 'InvId',
  Recurring: 'Recurring',
  RecurringIsDisabled: 'RecurringIsDisabled',
  amount: 'amount',
  generatedPaymentURL: 'generatedPaymentURL',
  confirmed: 'confirmed',
  confirmedNotificationData: 'confirmedNotificationData',
  confirmedAt: 'confirmedAt'
});

exports.Prisma.SectionV1ScalarFieldEnum = makeEnum({
  order: 'order',
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hidden: 'hidden',
  sectionParentsId: 'sectionParentsId',
  linkText: 'linkText',
  showLinkInHeader: 'showLinkInHeader',
  popupId: 'popupId',
  boxBlockId: 'boxBlockId'
});

exports.Prisma.SectionsPinnedScalarFieldEnum = makeEnum({
  id: 'id',
  pageId: 'pageId',
  footerSectionsId: 'footerSectionsId',
  headerSectionsId: 'headerSectionsId',
  order: 'order',
  sectionsCollectionId: 'sectionsCollectionId',
  isPinned: 'isPinned'
});

exports.Prisma.SectionsV1ScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  siteV1Id: 'siteV1Id',
  id: 'id'
});

exports.Prisma.SiteV1ScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  bitrixAddLeadURL: 'bitrixAddLeadURL',
  userId: 'userId',
  moveToUserId: 'moveToUserId',
  lastCacheUpdate: 'lastCacheUpdate',
  telegramSiteNotificationConnectCode: 'telegramSiteNotificationConnectCode',
  telegramSiteToChannelConfirmCode: 'telegramSiteToChannelConfirmCode',
  telegramSiteToTelegramUserConfirmCode: 'telegramSiteToTelegramUserConfirmCode',
  telegramGiftUserID: 'telegramGiftUserID',
  withBlockGroups: 'withBlockGroups',
  isTemplate: 'isTemplate',
  templatePictureId: 'templatePictureId',
  paidPlaceID: 'paidPlaceID',
  leadEmail: 'leadEmail',
  adminHidLabel: 'adminHidLabel',
  faviconId: 'faviconId',
  logoText: 'logoText',
  logoSubText: 'logoSubText',
  logoId: 'logoId',
  customScript: 'customScript',
  headScript: 'headScript',
  name: 'name',
  yandexMetrikaId: 'yandexMetrikaId',
  metrikaApiKey: 'metrikaApiKey',
  vkontaktePixelId: 'vkontaktePixelId',
  domainV1Id: 'domainV1Id',
  mainColorId: 'mainColorId'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.SystemDataWithStringIDScalarFieldEnum = makeEnum({
  id: 'id',
  telegramFailSending: 'telegramFailSending'
});

exports.Prisma.TableColumnScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  motherTableID: 'motherTableID',
  name: 'name',
  order: 'order',
  width: 'width',
  type: 'type',
  columnTableSchemaID: 'columnTableSchemaID'
});

exports.Prisma.TableConnectorScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteID: 'siteID',
  tableSchemaID: 'tableSchemaID',
  tableDataID: 'tableDataID'
});

exports.Prisma.TableDataScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pinnedToTableID: 'pinnedToTableID',
  siteID: 'siteID'
});

exports.Prisma.TableRowItemScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  number: 'number',
  imageID: 'imageID',
  tableDataID: 'tableDataID',
  tableColumnID: 'tableColumnID',
  tableRowID: 'tableRowID'
});

exports.Prisma.TableRowScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  slug: 'slug',
  tableDataID: 'tableDataID',
  order: 'order'
});

exports.Prisma.TableScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  siteID: 'siteID'
});

exports.Prisma.TargetScalarFieldEnum = makeEnum({
  id: 'id',
  shortID: 'shortID',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  siteID: 'siteID'
});

exports.Prisma.TargetsScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  andTargetsId: 'andTargetsId',
  orTargetsId: 'orTargetsId'
});

exports.Prisma.TelegramChannelScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  channelBigChatID: 'channelBigChatID',
  channelTitle: 'channelTitle',
  channelUserName: 'channelUserName',
  siteID: 'siteID'
});

exports.Prisma.TelegramGiftRecipientScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  userBigID: 'userBigID',
  userChatID: 'userChatID',
  subscribed: 'subscribed',
  goalIsLaunched: 'goalIsLaunched',
  telegramGiftID: 'telegramGiftID'
});

exports.Prisma.TelegramGiftScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  messageStringBigID: 'messageStringBigID',
  postBodyText: 'postBodyText',
  postLinkText: 'postLinkText',
  postImageID: 'postImageID',
  botBodyText: 'botBodyText',
  botLinkText: 'botLinkText',
  botDenyText: 'botDenyText',
  botPageID: 'botPageID',
  botImageID: 'botImageID',
  telegramChannelID: 'telegramChannelID',
  targetID: 'targetID',
  botID: 'botID'
});

exports.Prisma.TelegramNotificationScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  telegramUserID: 'telegramUserID',
  message: 'message',
  failedSending: 'failedSending',
  failedSendingResponseJSON: 'failedSendingResponseJSON'
});

exports.Prisma.TelegramPersonalBotScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  errorAtLaunch: 'errorAtLaunch',
  botID: 'botID',
  apiToken: 'apiToken',
  botName: 'botName',
  first_name: 'first_name',
  last_name: 'last_name',
  isDev: 'isDev',
  telegramChannelID: 'telegramChannelID'
});

exports.Prisma.TelegramUnsubsribeButWantsGiftScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  userBigID: 'userBigID',
  telegramGiftID: 'telegramGiftID'
});

exports.Prisma.TelegramUserScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  chatID: 'chatID',
  userID: 'userID',
  userName: 'userName',
  firstName: 'firstName',
  lastName: 'lastName'
});

exports.Prisma.TextComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  boxId: 'boxId',
  type: 'type',
  alignMobileResponsiveMode: 'alignMobileResponsiveMode',
  alignTabletResponsiveMode: 'alignTabletResponsiveMode',
  alignDesktopResponsiveMode: 'alignDesktopResponsiveMode',
  alignMobile: 'alignMobile',
  alignTablet: 'alignTablet',
  alignDesktop: 'alignDesktop',
  textSettingsId: 'textSettingsId'
});

exports.Prisma.TextSettingsScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  lib: 'lib',
  siteId: 'siteId',
  fontSizeMobileResponsiveMode: 'fontSizeMobileResponsiveMode',
  fontSizeTabletResponsiveMode: 'fontSizeTabletResponsiveMode',
  fontSizeDesktopResponsiveMode: 'fontSizeDesktopResponsiveMode',
  fontSizeMobile: 'fontSizeMobile',
  fontSizeTablet: 'fontSizeTablet',
  fontSizeDesktop: 'fontSizeDesktop',
  lineHeightMobileResponsiveMode: 'lineHeightMobileResponsiveMode',
  lineHeightTabletResponsiveMode: 'lineHeightTabletResponsiveMode',
  lineHeightDesktopResponsiveMode: 'lineHeightDesktopResponsiveMode',
  lineHeightMobile: 'lineHeightMobile',
  lineHeightTablet: 'lineHeightTablet',
  lineHeightDesktop: 'lineHeightDesktop',
  fontWeightMobileResponsiveMode: 'fontWeightMobileResponsiveMode',
  fontWeightTabletResponsiveMode: 'fontWeightTabletResponsiveMode',
  fontWeightDesktopResponsiveMode: 'fontWeightDesktopResponsiveMode',
  fontWeightMobileID: 'fontWeightMobileID',
  fontWeightTabletID: 'fontWeightTabletID',
  fontWeightDesktopID: 'fontWeightDesktopID'
});

exports.Prisma.TinkoffPaymentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  amount: 'amount',
  requestInitData: 'requestInitData',
  responseInitData: 'responseInitData',
  paymentId: 'paymentId',
  token: 'token',
  confirmed: 'confirmed',
  confirmedNotificationData: 'confirmedNotificationData',
  confirmedAt: 'confirmedAt',
  authorized: 'authorized',
  authorizedNotificationData: 'authorizedNotificationData',
  authorizedAt: 'authorizedAt',
  rejected: 'rejected',
  rejectedNotificationData: 'rejectedNotificationData',
  rejectedAt: 'rejectedAt',
  refunded: 'refunded',
  refundedNotificationData: 'refundedNotificationData',
  refundedAt: 'refundedAt'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  login: 'login',
  password: 'password',
  recoveryMailCode: 'recoveryMailCode',
  recoverySentAt: 'recoverySentAt',
  pinnedToPartnerID: 'pinnedToPartnerID',
  mailConfirmed: 'mailConfirmed',
  confirmationMailCode: 'confirmationMailCode',
  timeUserUsedFullFreeFunctional: 'timeUserUsedFullFreeFunctional',
  lastDateRobokassaRecurringPaymentInit: 'lastDateRobokassaRecurringPaymentInit',
  balance: 'balance',
  monthPayment: 'monthPayment',
  paymentForYearPerMonth: 'paymentForYearPerMonth',
  dailyPayment: 'dailyPayment',
  paid: 'paid',
  lastPaymentTime: 'lastPaymentTime',
  unlimited: 'unlimited',
  blocked: 'blocked',
  isAdmin: 'isAdmin'
});

exports.Prisma.VideoComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  videoURL: 'videoURL'
});

exports.Prisma.WBotComponentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  boxId: 'boxId',
  linkID: 'linkID'
});

exports.Prisma.WhatsAppBotLinkScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  text: 'text',
  whatsAppBotID: 'whatsAppBotID',
  targetID: 'targetID'
});

exports.Prisma.WhatsAppBotScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  siteID: 'siteID',
  phone: 'phone',
  qrCode: 'qrCode',
  connected: 'connected'
});

exports.Prisma.WhatsAppBotTargetScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  triggeredAt: 'triggeredAt',
  whatsAppBotLinkID: 'whatsAppBotLinkID',
  metrikaID: 'metrikaID'
});

exports.Prisma.WhatsAppMetrikaUserShortIDScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  whatsAppBotLinkID: 'whatsAppBotLinkID',
  triggeredAt: 'triggeredAt',
  metrikaID: 'metrikaID',
  shortCodeID: 'shortCodeID'
});
exports.BoxPositionType = makeEnum({
  Relative: 'Relative',
  Absolute: 'Absolute'
});

exports.BoxVector = makeEnum({
  Right: 'Right',
  Bottom: 'Bottom'
});

exports.FlexBoxPosition = makeEnum({
  FlexStart: 'FlexStart',
  Center: 'Center',
  FlexEnd: 'FlexEnd',
  SpaceBetween: 'SpaceBetween',
  SpaceAround: 'SpaceAround'
});

exports.HorizontalPosition = makeEnum({
  Left: 'Left',
  Center: 'Center',
  Right: 'Right'
});

exports.InputType = makeEnum({
  Phone: 'Phone',
  Text: 'Text'
});

exports.QuizV1StepV1CheckBoxItemType = makeEnum({
  CheckboxItemV1: 'CheckboxItemV1'
});

exports.QuizV1StepV1RadioItemType = makeEnum({
  RadioItemV1: 'RadioItemV1'
});

exports.QuizV1StepV1Type = makeEnum({
  CheckBoxV1: 'CheckBoxV1',
  RadioV1: 'RadioV1',
  FieldInput: 'FieldInput'
});

exports.ScreeenType = makeEnum({
  Mobile: 'Mobile',
  Tablet: 'Tablet',
  Desktop: 'Desktop'
});

exports.TableColumnType = makeEnum({
  Image: 'Image',
  Text: 'Text',
  Number: 'Number',
  Table: 'Table'
});

exports.TextComponentType = makeEnum({
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6',
  Paragraph: 'Paragraph'
});

exports.VerticalPosition = makeEnum({
  Top: 'Top',
  Center: 'Center',
  Bottom: 'Bottom'
});

exports.WidthType = makeEnum({
  Pixel: 'Pixel',
  Percent: 'Percent'
});

exports.Prisma.ModelName = makeEnum({
  SystemDataWithStringID: 'SystemDataWithStringID',
  DomainV1: 'DomainV1',
  TinkoffPayment: 'TinkoffPayment',
  RobokassaPayment: 'RobokassaPayment',
  IncomeBalance: 'IncomeBalance',
  OutcomeBalance: 'OutcomeBalance',
  PaidPlaceOutcomeBalance: 'PaidPlaceOutcomeBalance',
  PartnerIncome: 'PartnerIncome',
  PartnerOutcome: 'PartnerOutcome',
  Partner: 'Partner',
  GenerateGPTOutcomeBalance: 'GenerateGPTOutcomeBalance',
  User: 'User',
  TelegramUser: 'TelegramUser',
  TelegramNotification: 'TelegramNotification',
  Color: 'Color',
  CompanyPhone: 'CompanyPhone',
  CompanyAddress: 'CompanyAddress',
  PageV1: 'PageV1',
  SectionsPinned: 'SectionsPinned',
  SectionsV1: 'SectionsV1',
  SectionV1: 'SectionV1',
  PaidPlace: 'PaidPlace',
  TelegramUnsubsribeButWantsGift: 'TelegramUnsubsribeButWantsGift',
  TelegramGiftRecipient: 'TelegramGiftRecipient',
  TelegramGift: 'TelegramGift',
  TelegramChannel: 'TelegramChannel',
  TelegramPersonalBot: 'TelegramPersonalBot',
  BlockCategory: 'BlockCategory',
  SiteV1: 'SiteV1',
  WhatsAppBot: 'WhatsAppBot',
  WhatsAppBotLink: 'WhatsAppBotLink',
  WhatsAppBotTarget: 'WhatsAppBotTarget',
  WhatsAppMetrikaUserShortID: 'WhatsAppMetrikaUserShortID',
  TableConnector: 'TableConnector',
  Table: 'Table',
  TableColumn: 'TableColumn',
  TableData: 'TableData',
  TableRow: 'TableRow',
  TableRowItem: 'TableRowItem',
  CountVisit: 'CountVisit',
  GroupFont: 'GroupFont',
  FontWeight: 'FontWeight',
  BoxBlock: 'BoxBlock',
  Box: 'Box',
  ResponsiveBoxSettings: 'ResponsiveBoxSettings',
  BoxSettings: 'BoxSettings',
  BoxBorder: 'BoxBorder',
  BoxShadow: 'BoxShadow',
  BoxBackground: 'BoxBackground',
  TextComponent: 'TextComponent',
  TextSettings: 'TextSettings',
  ImageComponent: 'ImageComponent',
  FormComponent: 'FormComponent',
  QuizComponent: 'QuizComponent',
  VideoComponent: 'VideoComponent',
  FaqComponent: 'FaqComponent',
  FaqComponentItem: 'FaqComponentItem',
  MapComponent: 'MapComponent',
  CodeComponent: 'CodeComponent',
  WBotComponent: 'WBotComponent',
  MapComponentPoint: 'MapComponentPoint',
  PopupV1: 'PopupV1',
  LinkV1: 'LinkV1',
  ImageV1: 'ImageV1',
  FormV1: 'FormV1',
  ExtraInputV1: 'ExtraInputV1',
  QuizV1: 'QuizV1',
  QuizV1StepV1: 'QuizV1StepV1',
  QuizV1FieldInputStepV1: 'QuizV1FieldInputStepV1',
  QuizV1CheckboxStepV1: 'QuizV1CheckboxStepV1',
  QuizV1CheckboxItemV1: 'QuizV1CheckboxItemV1',
  QuizV1RadioStepV1: 'QuizV1RadioStepV1',
  QuizV1RadioItemV1: 'QuizV1RadioItemV1',
  LeadV1: 'LeadV1',
  Target: 'Target',
  ComplexTarget: 'ComplexTarget',
  OrTarget: 'OrTarget',
  AndTarget: 'AndTarget',
  Targets: 'Targets',
  PageOpenedEvent: 'PageOpenedEvent',
  BySecondsLaunchEvent: 'BySecondsLaunchEvent',
  FormSendedEvent: 'FormSendedEvent',
  PopupOpenedEvent: 'PopupOpenedEvent',
  CompanyMail: 'CompanyMail'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
